import React, { Component } from 'react';
import { Footer } from './Common/Footer';
import { HeaderMain } from './Common/HeaderMain';
import { ComPhoto, PopupAd } from '../js/ComponentManager';
import Big3Common from '../js/Big3Common';
import { Link } from 'react-router-dom';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,    
    Tooltip,
    LineController,
    BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
 

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:헤더와 풋터, 컨텐츠를 포함 하는 컴포넌트
*/
export class Home extends Component {
    static displayName = Home.name;
    constructor(props) {
        super(props);
        this.state = {
            TodayOrder:[],
            TotalOrder: [],
            SummaryBokmk: [],
            TodayTrunover: [],
            TotalTrunover: [],
            Popular_SaleCnt: [],
            Popular_ViewCnt: [],
            Popular_KeyWord:[],
            Popular_Category: [],
            Photo: [],
            ChartData: [],
            ChartOption: [],
            ChartHeight:"300px",
            Ord_Dt: "",
            ChartShow: false,
            Main_Notice: []

        };
         
        this.handleChartShow_Click = this.handleChartShow_Click.bind(this);
        
    }
    async componentDidMount() {
        
        ChartJS.register(
            LinearScale,
            CategoryScale,
            BarElement,
            PointElement,
            LineElement,
            Tooltip,
            LineController,
            BarController
        );

        try {
            Big3Common.Util.LoadingOn();
            let data = await Big3Common.Get("api/Home/GetMainInfomation");            
            if (data.codeName === Big3Common.ResultCode.Success) {
                const Data = JSON.parse(data.multiDataTable);

                const ChartHeight = Big3Common.Util.isMobile() === true ? "200px" : "300px";
                this.setState({
                    TodayOrder: Data.TodayOrder,
                    TotalOrder: Data.TotalOrder,
                    SummaryBokmk: Data.SummaryBokmk,
                    TodayTrunover: Data.TodayTrunover,
                    TotalTrunover: Data.TotalTrunover,
                    Popular_SaleCnt: Data.Popular_SaleCnt,
                    Popular_ViewCnt: Data.Popular_ViewCnt,
                    Popular_KeyWord: Data.Popular_KeyWord,
                    Popular_Category: Data.Popular_Category,
                    Photo: Data.Photo,
                    Ord_Dt: Data.Ord_Dt.replaceAll("-", "."),
                    ChartHeight: ChartHeight,
                    Main_Notice: Data.Main_Notice,

                });
                this.Chartrender(Data.Month_SalePrice, Data.Month_SaleCount);

            }          
        }
        catch (e) {
            console.log("componentDidMount: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff()
        }
    }
    handleChartShow_Click = (event) => {
        this.setState({ ChartShow: this.state.ChartShow === true ? false : true });
        event.preventDefault();
    }
    Chartrender(Month_SalePrice, Month_SaleCount) {
        const labels = Month_SaleCount.map(list => { return list.ord_dt_mm });
        const options = {
            maintainAspectRatio: false,
            title: {
                display: true,
                text: "Custom Chart"
            },
            legend: {
                display: false
            },
            scales: {
                x: {
                    title: {
                        display: false,
                        text: '매출현황'
                    }
                },
                'y-left': {
                    type: 'linear',
                    position: 'left',
                    title: {
                        display: true,
                        text: '거래건수'
                    },
                    grid: {
                        display: false
                    },
                },
                'y-right': {
                    type: 'linear',
                    position: 'right',
                    title: {
                        display: true,
                        text: '거래금액(만원)'
                    },
                    grid: {
                        display: false
                    },
                },
            },
        };

        const data = {
            labels,
            datasets: [
                {
                    type: 'line',
                    label: '거래건수',
                    backgroundColor: [
                        'rgba(13, 46, 123, 0.2)'
                    ],
                    data: Month_SaleCount.map(list => { return list.ord_count }),
                    borderColor: 'rgba(13, 46, 123, 0.5)',
                    borderWidth: 3,
                    yAxisID: 'y-left'
                },
                {
                    type: 'bar',
                    label: '거래금액',
                    backgroundColor: [
                        'rgba(205, 220, 255, 0.2)',
                        'rgba(13, 46, 123, 0.2)',
                        'rgba(67, 110, 225, 0.2)',
                        'rgba(23, 73, 186, 0.2)'
                    ],
                    data: Month_SalePrice.map(list => { return list.trunover }),
                    borderColor: 'white',
                    borderWidth: 1,
                    yAxisID: 'y-right'
                }
            ],
             
        };        
       
        this.setState({ ChartData: data, ChartOption: options });
    }
    //도매명
    OrgNamerender() {
        const Photo = this.state.Photo;
        if (Photo.length === 0) return false;
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        let _Photo = "";
        if (Photo[0].photo !== null) {
            _Photo = Photo[0].photo
        }
        else if (Photo[0].picture != null) {
            _Photo = `${VirtualRoot}${Photo[0].picture}`
        }
        return (
            <div className="profile_box">
                <ComPhoto className="profile_photo"
                    Photo={_Photo}
                />
                <div className="profile_name">
                    <span>{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.OrgName)}</span> 님<br /> 환영합니다! &#x1F389;
                </div>
            </div>
        )
    }
    //주문현황
    OrderStaterender() {
        const TodayOrder = this.state.TodayOrder;
        const TotalOrder = this.state.TotalOrder;
       
        if (TodayOrder.length === 0) return false;
        const today_order = Big3Common.Util.Money(TodayOrder[0].today_order || 0);
        const today_uid_cnt = Big3Common.Util.Money(TodayOrder[0].union_uid_cnt || 0);
        const total_order = Big3Common.Util.Money(TotalOrder[0].today_order || 0);
        const total_uid_cnt = Big3Common.Util.Money(TotalOrder[0].union_uid_cnt || 0);
        return (
            <>
                <div className="wh_info_box">
                    <div className="title">주문현황&#x1F4CA;</div>
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="today-tab" data-bs-toggle="pill" data-bs-target="#today" type="button" role="tab" aria-controls="today" aria-selected="true">Today</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="total-tab" data-bs-toggle="pill" data-bs-target="#total" type="button" role="tab" aria-controls="total" aria-selected="false">Total</button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="today" role="tabpanel" aria-labelledby="today-tab">
                            <div className="base_date">
                                오늘 기준 ({this.state.Ord_Dt})
                            </div>
                            <div className="wh_order_data">
                                <div className="title">오늘의 주문수</div>
                                <div className="number">{today_order}건</div>
                            </div>
                            <div className="wh_order_data">
                                <div className="title">오늘의 주문매장</div>
                                <div className="number">{today_uid_cnt}곳</div>
                            </div>

                        </div>
                        <div className="tab-pane fade" id="total" role="tabpanel" aria-labelledby="total-tab">
                            <div className="base_date">
                                가입일부터 오늘({this.state.Ord_Dt})까지 기준
                            </div>
                            <div className="wh_order_data">
                                <div className="title">총 주문수</div>
                                <div className="number">{total_order}건</div>
                            </div>
                            <div className="wh_order_data">
                                <div className="title">총 주문매장</div>
                                <div className="number">{total_uid_cnt}건</div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.AiFitting()}
            </>

        )
    }
    //총상품수, 찜, 내거래처
    Boomarkrender() {
        const SummaryBokmk = this.state.SummaryBokmk;
        if (SummaryBokmk.length === 0) return false;
        const bokmk_count = Big3Common.Util.Money(SummaryBokmk[0].bokmk_count || 0);
        const goods_count = Big3Common.Util.Money(SummaryBokmk[0].goods_count || 0);
        const retail_count = Big3Common.Util.Money(SummaryBokmk[0].retail_count || 0);
        return (
            <div className="wh_cs_box">
                <div className="wh_info_box_v2">
                    <div className="icon">&#x1F381;</div>
                    <div className="title">총 상품수</div>
                    <div className="number">{goods_count}</div>
                </div>
                <div className="wh_info_box_v2">
                    <div className="icon">&#128149;</div>
                    <div className="title">찜</div>
                    <div className="number">{bokmk_count }</div>
                </div>
                <div className="wh_info_box_v2">
                    <div className="icon">&#x1F3E2;</div>
                    <div className="title">내 거래처</div>
                    <div className="number">{retail_count }</div>
                </div>
            </div>
        )
    }
    AiFitting = () => {
        return (
            <div className="wh_info_box ai_fitting_box">
                <div className="ai_fitting_content">
                    <div className="ai_fitting_item">
                        <div className="ai_fitting_icon">🤖</div>
                        <div className="ai_fitting_text">AI로 손쉽게 피팅을 해보세요.</div>
                    </div>

                    <div className="ai_fitting_item">
                        <div className="ai_fitting_icon">💰</div>
                        <div className="ai_fitting_text">모델 촬영 비용의 최대 60% 절감.</div>
                    </div>

                    <div className="ai_fitting_item">
                        <div className="ai_fitting_icon">📊</div>
                        <div className="ai_fitting_text">원하는 배경으로 자유롭게 연출 !!</div>
                    </div>

                    <div className="ai_fitting_buttons">
                        <button className="ai_fitting_btn primary" onClick={() => { Big3Common.Util.OpenWindowLink("https://clod-ai.com", true) }}>AI스튜디오</button>
                        <Link to="/AIStudio/AIFittingMgr"> <button className="ai_fitting_btn secondary">신청하기</button></Link>
                    </div>
                </div>
            </div>
        )
    }
    //상품매출현황
    Trunoverrender() {
        const TodayTrunover = this.state.TodayTrunover;
        const TotalTrunover = this.state.TotalTrunover;
        if (TodayTrunover.length === 0) return false;
        const today_trunover = Big3Common.Util.Money(TodayTrunover[0].trunover || 0);
        const total_trunover = Big3Common.Util.Money(TotalTrunover[0].trunover || 0);
        return (
            <div className="wh_info_box">
                <div className="title">상품매출현황&#128176;</div>
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="today-tab2" data-bs-toggle="pill" data-bs-target="#sales_today" type="button" role="tab" aria-controls="sales_today" aria-selected="true">Today</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="total-tab2" data-bs-toggle="pill" data-bs-target="#sales_total" type="button" role="tab" aria-controls="sales_total" aria-selected="false">Total</button>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="sales_today" role="tabpanel" aria-labelledby="today-tab2">
                        <div className="base_date">
                            오늘 기준 ({this.state.Ord_Dt})
                        </div>
                        <div className="wh_order_data2">
                            <div className="number">{today_trunover }원</div>
                        </div>

                    </div>
                    <div className="tab-pane fade" id="sales_total" role="tabpanel" aria-labelledby="total-tab2">
                        <div className="base_date">
                            가입일부터 오늘({this.state.Ord_Dt})까지 기준
                        </div>
                        <div className="wh_order_data2">
                            <div className="number">{total_trunover }원</div>
                        </div>
                    </div>
                </div>
                <div className="open_data">
                    <p className="accordion-button collapsed" type="button" onClick={this.handleChartShow_Click }>
                        최근 3개월 현황보기
                    </p>
                </div>
                <div id="flush-collapseOne" className={this.state.ChartShow === false ? "accordion-collapse collapse" : "accordion-collapse collapse show"} >
                    <div className="graph_box" style={{ margin: "0 auto", height: `${this.state.ChartHeight}`, boxSizing: "border-box" }}>
                        <Chart type='bar' data={this.state.ChartData}
                            width="100%"
                            options={this.state.ChartOption}
                        ></Chart>
                    </div>
                </div>
            </div>
        )
    }
    PopularGoodsrender() {
        const Popular_ViewCnt = this.state.Popular_ViewCnt;
        const Popular_SaleCnt = this.state.Popular_SaleCnt;
        if (Popular_ViewCnt.length === 0) return false;
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
       
        return (

            <div className="wh_info_box">
                <div className="title">나의 인기상품&#10024;</div>
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="views-tab" data-bs-toggle="pill" data-bs-target="#views" type="button" role="tab" aria-controls="views" aria-selected="true">조회수</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="sales_volume-tab" data-bs-toggle="pill" data-bs-target="#sales_volume" type="button" role="tab" aria-controls="sales_volume" aria-selected="false">판매량</button>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="views" role="tabpanel" aria-labelledby="views-tab">
                        <div className="base_date">
                            오늘 기준 ({this.state.Ord_Dt})
                        </div>
                        <div className="wh_order_data">
                            <div className="ranking_data_box">
                                {Popular_ViewCnt.map((list, idx) =>
                                    <div className="ranking_data" key={idx}>
                                        <div className="ranking">{idx + 1}</div>
                                        <ComPhoto className="p_img"
                                            Photo={`${VirtualRoot}${list.img_100}`}
                                        />
                                        <div className="p_name">{list.goods_nm}</div>
                                        <div className="data">{Big3Common.Util.Money(list.view_cnt || 0)}회</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="sales_volume" role="tabpanel" aria-labelledby="sales_volume-tab">
                        <div className="base_date">
                            오늘 기준 ({this.state.Ord_Dt})
                        </div>
                        <div className="wh_order_data">
                            <div className="ranking_data_box">
                                {Popular_SaleCnt.map((list, idx) =>
                                    <div className="ranking_data" key={idx}>
                                        <div className="ranking">{idx + 1}</div>
                                        <ComPhoto className="p_img"
                                            Photo={`${VirtualRoot}${list.img_100}`}
                                        />
                                        <div className="p_name">{list.goods_nm}</div>
                                        <div className="data">{Big3Common.Util.Money(list.view_cnt || 0)}회</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        
    }
    Popularrender() {
        const Popular_KeyWord = this.state.Popular_KeyWord;
        const Popular_Category = this.state.Popular_Category;
        if (Popular_KeyWord.length === 0) return false;        
        return (
            <div className="wh_info_box">
                <div className="title">인기키워드&#128526;</div>
                <div className="base_date2"> 오늘({this.state.Ord_Dt})기준</div>
                <ul className="hot_keyword">
                    {Popular_KeyWord.map((list, idx) =>
                        idx === 0 ? <li className="top_keyword" key={idx}>&#128293;#{list.sch_text}</li> : <li key={idx}>#{list.sch_text}</li>
                    )}
                    {Popular_Category.map((list, idx) =>
                        idx === 0 ? <li className="top_catagory" key={idx}>&#x1F3C6;#{list.category_nm}</li> : <li key={idx}>#{list.category_nm}</li>
                    )}
                </ul>
            </div>
        )
    }
    NoticeRender() {
        let Main_Notice = [];
        const Data_Main_Notice = this.state.Main_Notice;

        if (Big3Common.Util.GetContentState(Data_Main_Notice, null) !== null) {
            Main_Notice = Data_Main_Notice;
        }
        
        if (Main_Notice.length === 0) {
            return null;
        }

        const Title = Main_Notice[0].noti_title;
        const Notino = Main_Notice[0].notino;
        const Noti_Idx = Main_Notice[0].noti_idx;
        const WUid = Main_Notice[0].wuid

        const Url = `/MyPage/Notice/Index?Notino=${Notino}&Noti_Idx=${Noti_Idx}&WUid=${WUid}`;
        return (
            <div className="notice_info_box_wrap">
                <Link to={Url}>
                    <div className="notice_info_box">
                        {Title}
                        <div className="close"></div>
                    </div>
                </Link>
            </div>
        )
    }
        
    render() {
        

            return (
                <div className="wrap_m" style={{ overflow: 'hidden' }}>
                    {this.NoticeRender()}    

                    {/*헤더메인 Page[S]*/}
                    <HeaderMain
                        ComponentName="Home"
                    />
                    {/*헤더메인 Page[E]*/}
                    <>
                        <div className="main_box">
                            {this.OrgNamerender()}
                            {this.OrderStaterender()}
                           
                            {this.Boomarkrender()}
                            {this.Trunoverrender()}
                            {this.PopularGoodsrender()}
                            {this.Popularrender()}
                        </div>

                        <div className="product_btn_box">
                            <Link className="product_btn1" to="/Goods/RegisterMgr/Index">
                                <div>상품등록</div>
                                <p></p>
                            </Link>
                            <Link className="product_btn2" to="/Goods/GoodsMgr/Index">
                                <div>상품관리</div>
                                <p></p>
                            </Link>
                        </div>
                        <PopupAd id="PopupAd" />
                    </>
                    {/*풋터 Page[S]*/}
                    <Footer
                        ComponentName="Home"
                        fillName="icon3"
                    />
                    {/*풋터 Page[E]*/}
                </div>
            );
        
        
    }
}

